import styled from 'styled-components'

export const DateTimeContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0px;
    justify-content: space-between;
    align-items: center;
`

export const SelectedDateTime = styled.div`
    display: flex;
    align-items: center;
    span{
        margin: 0px 8px;
    }   
`

export const DeliverVal = styled.span`
    color:#bf7b00;
`